import { http_campaign } from './HttpService.js'

export default {
	load() {
    return http_campaign.get('campaign');
	},

	loadEditcampaign(idCampaign) {
    return http_campaign.get('campaign/' + idCampaign);
	},

	post(metadata) {
    return http_campaign.post('campaign', metadata);
	},

  patch(idCampaign, metadata, iframeAdded){
    return http_campaign.patch('campaign/' + idCampaign, {metadata, iframeAdded});
  },

	delete(idCampaign) {
    return http_campaign.delete('campaign/' + idCampaign);
	},
}
